import { vendors } from '../config/vendor';

/**
 * @param {Number} unformattedPrice
 * @param {String} vendor
 *
 * @return {String}
 */
const currencyFormatter = (unformattedPrice: string | number, vendor: string): string | null => {
    if (!unformattedPrice || !vendor || !(vendor in vendors)) {
        return null;
    }

    // Round half down so that 10.995 becomes 10.99 not 11
    // We can do it by rounding a negative result:
    // Math.round(0.5)=1 but -Math.round(-0.5)=0
    unformattedPrice = -Math.round(-parseFloat(unformattedPrice as string) * 100) / 100;
    unformattedPrice = unformattedPrice.toFixed(2);
    unformattedPrice = parseFloat(unformattedPrice);

    return unformattedPrice.toLocaleString(vendors[vendor].locale, {
        style: 'currency',
        currency: vendors[vendor].currency,
    });
};

export default currencyFormatter;
